import React, { useCallback, useEffect, useState } from 'react'
import { Form, Spinner } from 'react-bootstrap'
import styled from 'styled-components'
import { colors } from '../../../styles/colors'
import apiClient from '../../../utils/api/apiClient'
import { APIEndpoints } from '../../../utils/api/apiConfig'
import ArraySelect from '../../Select/ArraySelect'
import { emptyGuid } from '../../../utils/emptyGuid.js'
import i18n from '../../../translation/i18n'
import useStores from '../../../stores/useStore'

const StyledSize = styled.div`
  color: ${colors.gray3};
  font-weight: 600;
`

const VariantSelect = ({ articleId, handleOnChange, selectedVariant, formError }) => {
    const [variantsLoading, setVariantsLoading] = useState(true)
    const [loadedVariants, setLoadedVariants] = useState(null)
    const { productsStore } = useStores()
    const getVariants = useCallback(async () => {
        try {
            let variants = await apiClient.getJson(APIEndpoints.shoppingBasketArticleVariants(productsStore.basket.id, articleId))
            setLoadedVariants(variants)
        }
        catch (e) { }
        finally {
            setVariantsLoading(false)
        }
    }, [articleId, productsStore.basket.id])


    useEffect(() => {
        getVariants()
    }, [getVariants])

    if (variantsLoading || !loadedVariants) {
        return <div className='d-flex justify-content-center p-5'><Spinner animation='border' variant='primary' /></div>
    }
    if (!loadedVariants.length) return null
    return <Form.Group className="mb-3">
        <ArraySelect
            id={`variantId`}
            onChange={handleOnChange}
            value={selectedVariant.id}
            options={loadedVariants}
            isInvalid={!!formError}
            defaultOption={{ value: emptyGuid, name: i18n.t('pleaseSelect') }}
        //defaultOptionIsSelectable
        />
        <Form.Control.Feedback type="invalid">
            {formError}
        </Form.Control.Feedback>
    </Form.Group>
}

const VariantSelector = ({ articleId, selectedVariant, disabled = false, handleOnChange, formError }) => {

    return (
        <>
            {!disabled
                ? <VariantSelect articleId={articleId} handleOnChange={handleOnChange} selectedVariant={selectedVariant} formError={formError} />
                : <StyledSize>{selectedVariant.displayName}</StyledSize>
            }
        </>
    )
}

export default VariantSelector